import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@mui/material';
import { FormControl } from 'react-bootstrap';
import { getIn } from 'formik';

import CustomLabel from '../CustomLabel';
import ErrorFeedbackP from '../ErrorFeedbackP';

const CustomFormControl = ({
  id,
  label,
  onChange,
  onBlur,
  touched,
  errors,
  value,
  type,
  info,
  required,
  maxLength,
  min,
  max,
  noMarginTop,
  ...props
}) => {
  return (
    <Box>
      <CustomLabel
        htmlFor={id}
        required={required}
        info={info}
        noMarginTop={noMarginTop}
      >
        {label}
      </CustomLabel>
      <FormControl
        type={type}
        id={id}
        name={id}
        data-testid={id}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        min={min}
        max={max}
        maxLength={maxLength}
        {...props}
      />
      <ErrorFeedbackP
        touched={getIn(touched, id)}
        error={getIn(errors, id)}
        maxLength={maxLength}
      />
    </Box>
  );
};

CustomFormControl.defaultProps = {
  type: 'text',
  info: '',
  required: false,
  noMarginTop: false,
  maxLength: 255,
};

CustomFormControl.propTypes = {
  errors: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
  maxLength: PropTypes.number,
  type: PropTypes.string,
  info: PropTypes.any,
  required: PropTypes.bool,
  noMarginTop: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
};

export default CustomFormControl;
